import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/credit-connect/headerRightBg.png';
import headerRightBg375 from '../images/credit-connect/headerRightBg375.png';
import WomanLaptopDashboard from '../images/credit-connect/WomanLaptopDashboard.svg';
import EmailContactSales from '../components/EmailContactSales';
import ProblemSolution from '../components/ProblemSolution';
import FeaturesAndBenefits from '../components/FeaturesAndBenefits';
import HeadDownArrow from '../images/credit-connect/HeadDownArrow.svg';
import Fingerprint from '../images/credit-connect/Fingerprint.svg';
import HeadMagGlass from '../images/credit-connect/HeadMagGlass.svg';
import halfSectionGradient from '../images/app-flow/halfSectionGradient.png';
import fullWidthSplitBg from '../images/app-flow/fullWidthSplitBg.png';
import iPadDashboardOrder from '../images/credit-connect/iPadDashboardOrder.png';
import WantToSeeHow from '../components/WantToSeeHow';
import Testimonial from '../components/Testimonial';
import SaraHafeman from '../images/credit-connect/SaraHafeman.jpg';
import TimeInvestmentCompany from '../images/credit-connect/TimeInvestmentCompany.png';




const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 490px;
	}
`;

const CreditConnectHeaderContent =
	<HeaderContent style={{marginTop: `0`, paddingTop: `80px`}}>
		<h1>CreditConnect</h1>
		<p>Realtime credit pulls<br />with tri-bureau connection</p>
		<EmailContactSales />
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 90%;
		margin-top: 2em;
		margin-bottom: 2em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
			margin-bottom: 1em;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 417px;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
		}
	}
`;

const WomanLaptopDashboardFigure =
	<HeaderBottomContentFigure>
		<WomanLaptopDashboard alt='Woman with laptop connected to a credit bureau' className='bottomAligned' />
	</HeaderBottomContentFigure>
;

const Section = styled.section`

	&.full-width-split {

		@media (${(props) => props.theme.mediumUp}) {
			& .responsivePadding#alignStretch {
				align-items: stretch;

				& article {
					align-items: center;
					display: flex;
				}
			}
		}

		& figure#laptopWithLogos {
			background-color: #5cd3f2;
			background-image: ${(props) => `url('${halfSectionGradient}')`};
			align-items: center;
			padding-top: 40px;
			padding-bottom: 40px;

			@media (${(props) => props.theme.mediumUp}) {
				padding-left: 40px;
				padding-top: 60px;
				padding-bottom: 60px;
			}

			@media (${(props) => props.theme.largeUp}) {
				padding-left: 60px;
				padding-top: 70px;
				padding-bottom: 70px;
			}

			/* ie11 */

			@media all and (-ms-high-contrast: none) {
				& img {
					max-width: 345px;
					max-height: 194px;
				}
			}

			@media (${(props) => props.theme.smallUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 530px;
					max-height: 298px;
				}
			}

			@media (${(props) => props.theme.mediumUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 260px;
					max-height: 146px;
				}
			}

			@media (${(props) => props.theme.largeUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 333px;
					max-height: 187px;
				}
			}

			@media (${(props) => props.theme.xLargeUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 483px;
					max-height: 271px;
				}
			}
		}
	}

	@media (${(props) => props.theme.mediumUp}) {
		&.whiteLeftLtBlueRight {
			background-image: ${(props) => `url('${fullWidthSplitBg}')`};
		}
	}
`;

const CreditConnectPage = (props: any) => {
	return (
	<Layout
		headerSplashBg={headerRightBg}
		headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'100% 100%'}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPosition={'right top'}
		headerSplashBgPositionLarge={'center top'}
		headerSplashAlignItemsLarge={'flex-end'}
		headerBottomContent={WomanLaptopDashboardFigure}
		headerContentClass={'product'}
		headerContent={CreditConnectHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='CreditConnect - Credit Bureau APIs'
		metaDescription={'Integrate with your preferred credit bureau for a full suite of identity verification products and access to credit profiles quickly and securely.'}
		skipMoney2020={true}
		splashHeaderMinHeight={'460px'}
		BodyClass={'CreditConnect'}
	>
		<ProblemSolution
			problem={'Financial institutions have cumbersome, time-intensive processes when manually collecting customer credit data.'}
			solution={'CreditConnect gives financial institutions access to credit bureaus with a single click of a button, eliminating time-consuming data entry processes.'}
		/>
		{/* <Testimonial
			portrait={SaraHafeman}
			portraitAlt={'Sara Hafeman'}
			name={'Sara Hafeman'}
			title={'Director of Dealer Development/ Marketing'}
			company={'Time Investment Company'}
			quote={'Partnering with MK to integrate Experian’s credit profile, income insights, and OFAC and MLA datasets was a seamless experience. We’re grateful for our Experian Account Executive, David Smidt, who went above and beyond to keep our team informed on the latest products and for the MK team because they truly care about building long-lasting relationships and providing the best customer service in the market.'}
			logo={TimeInvestmentCompany}
			logoAlt={'Time Investment Company Logo'}
		/> */}
		<FeaturesAndBenefits
			solidBgColor = {'#5cd3f2'}

			leftIcon = {<HeadDownArrow alt='download profile icon' style={{margin: `0`}} />}
			leftHeading = {'Downloadable\ncredit profiles'}
			leftText={'Expedite data entry by pulling credit profiles quickly and securely.'}

			middleIcon = {<Fingerprint alt='Fingerprint icon' style={{margin: `0 0`}} />}
			middleHeading = {'Device\nIdentification'}
			middleText = {'Scan bureau databases of known fraudulent devices.'}

			rightIcon = {<HeadMagGlass alt='Profile under magnifying glass icon' style={{margin: `9px 0`}} />}
			rightHeading = {'Out-of-Wallet\nquestions'}
			rightText = {'Protect against identity theft through streamlined KYC questions.'}
		/>
		<Section className='full-width-split full-width whiteLeftLtBlueRight'>
			<div className='centeredWrapper'>
				<div className='responsivePadding row row-flush' id='alignStretch'>
					<article className='col-12 col-md-6'>
						<div className='product text-box'>
							<header>
								<h2>Consolidate your loan origination workflow</h2>
							</header>
							<p>Stop wasting time pulling credit and focus on your community's needs. Manual logins and credit reports in notepad format are a thing of the past. Benefit from easy-to-read credit reports and increased security by transferring credit data between trusted systems.</p>
							<p>The time is now to let the system work for you, not against you, by utilizing MK's full suite of credit bureau products.</p>
						</div>
					</article>
					<figure className='col-12 col-md-6 left-on-desktop' id='laptopWithLogos'>
						<img src={iPadDashboardOrder} alt='tablet with MK credit decisioning dashboard' />
					</figure>
				</div>
			</div>
		</Section>
		<div className='centeredWrapper'>
			<WantToSeeHow />
		</div>
	</Layout>
	);
};

export default CreditConnectPage;
